export default "__VITE_ASSET__Jh$r7k95__"